import * as React from "react";
import { ui } from "../../../../dependencies";
export const PreliveOutrightHeading = (props) => React.createElement(React.Fragment, null,
    React.createElement(ui.SubHeading, null,
        React.createElement("div", { className: `rj-sub-heading-inner rj-sub-heading-inner--${props.componentPrefix.toLowerCase()}` },
            React.createElement(ui.HeadingTitle, { name: props.name, count: "" }),
            props.mbnTag &&
                React.createElement(ui.MbnIcon, { tagNumber: props.mbnTag }))),
    props.children);
//# sourceMappingURL=PreliveOutrightHeading.js.map